// extracted by mini-css-extract-plugin
export default {"tooltip":"xo-z","sharingV2":"yo-z","sharingIconsV2":"zo-z","links":"Ao-z","link":"Bo-z","facebookV2":"Co-z","twitterV2":"Do-z","pinterestV2":"Eo-z"};